// Horarios de inicio de aula no vinculo pelo link (card 17trt6je405): das
// 06:00 as 22:30, de meia em meia hora.
export const hours = Array.from({ length: (23 - 6) * 2 }, (_, index) => {
  const minutes = 6 * 60 + index * 30;
  const hour = String(Math.floor(minutes / 60)).padStart(2, "0");
  return `${hour}:${minutes % 60 ? "30" : "00"}`;
});
